import React, { ReactNode } from 'react'
import {
    CardBody,
    CardBodyInner,
    CardContainer,
    CardHeader,
    CardHeaderText,
    SpinnerContainer
} from './ParkingCard.style'
import Spinner from 'parkdepot-shared/components/Spinner'

interface ParkingCardProps {
    isLast?: boolean
    disabled?: boolean
    loading?: boolean
    onClick?: () => void
    children: ReactNode
    className?: string
}

const ParkingCard = ({
    children,
    isLast = true,
    disabled = false,
    loading = false,
    onClick,
    className
}: ParkingCardProps) => (
    <CardContainer
        role="button"
        $isLast={isLast}
        $loading={loading}
        onClick={onClick}
        $disabled={disabled}
        disabled={disabled}
        className={className}
    >
        {children}

        {loading && (
            <SpinnerContainer>
                <Spinner theme="primary" size="lg" />
            </SpinnerContainer>
        )}
    </CardContainer>
)

// Subcomponents
const Header = ({ children }: { children: ReactNode }) => <CardHeader>{children}</CardHeader>

const HeaderText = ({ children }: { children: ReactNode }) => <CardHeaderText>{children}</CardHeaderText>

const Content = ({ children }: { children: ReactNode }) => <CardBody>{children}</CardBody>

const InnerContent = ({ children }: { children: ReactNode }) => <CardBodyInner>{children}</CardBodyInner>

ParkingCard.Header = Header
ParkingCard.HeaderText = HeaderText
ParkingCard.Content = Content
ParkingCard.InnerContent = InnerContent

export default ParkingCard
